module.exports = __webpack_public_path__ + "img/hands.518f284a.svg";